<template>
  <v-row class="border-sm border-solid border-primary">
    <v-col cols="12" sm="1" md="1" lg="1">
      <v-icon class="cursor-move">mdi-drag</v-icon>
    </v-col>
    <v-col cols="12" :sm="isLast ? 11 : 10" :md="isLast ? 11 : 10" :lg="isLast ? 11 : 10">
      <v-row>
        <v-col cols="12" sm="5" md="3" lg="3" class="ignore-drag">
          <v-select
            v-model="castCrew.castCrew"
            label="Cast/Crew"
            :items="data?.data"
            :item-props="itemProps"
            @update:model-value="emit('updated', castCrew, castCrew.order)"
            :rules="[rules.required]"></v-select>
        </v-col>
        <v-col cols="12" sm="5" md="3" lg="3" class="ignore-drag">
          <v-text-field
            v-model="castCrew.first_name"
            label="First Name"
            :rules="[rules.required]"
            @update:model-value="emit('updated', castCrew, castCrew.order)" />
        </v-col>
        <v-col cols="12" sm="5" md="3" lg="3" class="ignore-drag">
          <v-text-field
            v-model="castCrew.last_name"
            label="Last Name"
            :rules="[rules.required]"
            @update:model-value="emit('updated', castCrew, castCrew.order)" />
        </v-col>
        <v-col cols="12" sm="5" md="3" lg="3" class="ignore-drag">
          <v-text-field
            v-model="castCrew.email_address"
            label="Email Address"
            :rules="[rules.email]"
            @update:model-value="emit('updated', castCrew, castCrew.order)" />
        </v-col>

        <v-col cols="12" sm="5" md="3" lg="3" v-if="isActor" class="ignore-drag">
          <v-text-field
            v-model="castCrew.character_name"
            label="Character"
            :rules="[rules.required]"
            @update:model-value="emit('updated', castCrew, castCrew.order)" />
        </v-col>
        <v-col cols="12" sm="5" md="3" lg="3" v-if="isOther" class="ignore-drag">
          <v-text-field
            v-model="castCrew.other_cast_crew"
            label="Crew Title"
            :rules="[rules.required]"
            @update:model-value="emit('updated', castCrew, castCrew.order)" />
        </v-col> </v-row
    ></v-col>
    <v-col cols="12" md="1" v-if="!isLast" class="ignore-drag d-flex justify-end">
      <v-icon color="primary" @click="emit('remove', castCrew.order)">mdi-trash-can-outline</v-icon>
    </v-col>
  </v-row>
</template>
<script lang="ts" setup>
import { CastCrewDTO, ISubmissionCastCrewDTO, SubmissionCastCrewDTO } from '@/dtos';
import { computed, ref, watch } from 'vue';
import { rules } from '@/helpers';
import { useCastCrewStore } from '@/stores/modules/castcrew';

const props = defineProps<{
  castCrew?: ISubmissionCastCrewDTO;
  isLast?: boolean;
}>();
const emit = defineEmits<{
  (e: 'remove', value: number): void;

  (e: 'updated', value: ISubmissionCastCrewDTO, order: number): void;
}>();

function itemProps(item: CastCrewDTO) {
  return {
    title: item.name,
    subtitle: item.description,
  };
}
const isLast = computed(() => props.isLast ?? true);
const isActor = ref<boolean>(false);
const isOther = ref<boolean>(false);
const castCrew = ref<SubmissionCastCrewDTO>(new SubmissionCastCrewDTO());
const castCrewStore = useCastCrewStore();
const { data } = castCrewStore.getAllCastAndCrewSettings();

watch(
  () => props.castCrew,
  (newValue?: SubmissionCastCrewDTO) => {
    if (newValue) {
      castCrew.value = new SubmissionCastCrewDTO(newValue);
    } else {
      castCrew.value = new SubmissionCastCrewDTO();
    }
  },
  { immediate: true },
);

watch(
  () => castCrew.value.castCrew,
  (newValue) => {
    isActor.value = newValue ? newValue.name.includes('Actor') : false;
    isOther.value = newValue ? newValue.name.includes('Other') : false;
  },
  { immediate: true },
);
</script>
